import { gettext } from '@eventbrite/i18n';
import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import { useIsMobileDevice } from '@eventbrite/feature-detection';
import {
    HALLOWEEN_COLLECTION_TO_SLUG_MAPPING,
    HALLOWEEN_COLLECTIONS_TOUCHPOINT_IMAGES,
} from '../../constants';
import React from 'react';
import styles from './HalloweenCollectionsTouchpoint.module.scss';

export const HalloweenCollectionsTouchpoint = (props) => {
    const { collectionId } = props;
    const isMobile = useIsMobileDevice();

    if (
        !Object.hasOwnProperty.call(
            HALLOWEEN_COLLECTION_TO_SLUG_MAPPING,
            collectionId,
        )
    ) {
        return null;
    }

    const ctaLink = `/b/${HALLOWEEN_COLLECTION_TO_SLUG_MAPPING[collectionId]}/holiday/halloweenhaunt/`;

    const halloweenTouchpointTitle = gettext(
        'Spooky or kooky, we’ve got just the thing.',
    );
    const halloweenTouchpointSubtitle = !isMobile
        ? gettext('This Halloween, find your perfect plans')
        : null;

    const touchpointData = [
        {
            className: styles.halloweenCollectionsTouchpointTitle,
            text: halloweenTouchpointTitle,
        },
        {
            className: styles.halloweenCollectionsTouchpointSubtitle,
            text: halloweenTouchpointSubtitle,
        },
    ];

    return (
        <div className={styles.halloweenCollectionsTouchpoint}>
            <div className={styles.halloweenCollectionsTouchpointContainer}>
                <div
                    className={
                        styles.halloweenCollectionsTouchpointImageTextContainer
                    }
                >
                    <img
                        className={
                            styles.halloweenCollectionsTouchpointImageContainer
                        }
                        src={
                            isMobile
                                ? HALLOWEEN_COLLECTIONS_TOUCHPOINT_IMAGES[
                                      'imgMobile'
                                  ]
                                : HALLOWEEN_COLLECTIONS_TOUCHPOINT_IMAGES[
                                      'imgDesktop'
                                  ]
                        }
                        alt="Halloween Touchpoint"
                    />
                    <div
                        className={
                            styles.halloweenCollectionsTouchpointTextContainer
                        }
                        data-testid="halloween-collections-touchpoint-title-subtitle"
                    >
                        {touchpointData.map((item, index) => (
                            <Typography
                                key={index}
                                as="h2"
                                className={item.className}
                            >
                                {item.text}
                            </Typography>
                        ))}
                    </div>
                </div>
                <a
                    href={ctaLink}
                    data-heap-id="halloween_collections_touchpoint_click"
                >
                    <Button
                        className={styles.halloweenCollectionsTouchpointButton}
                    >
                        <span
                            className={
                                styles.halloweenCollectionsTouchpointButtonText
                            }
                        >
                            {gettext('Find Your Halloween')}
                        </span>
                        <ArrowRightIcon
                            className={
                                styles.halloweenCollectionsTouchpointArrowRight
                            }
                        />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default HalloweenCollectionsTouchpoint;
